import axios, { AnyResponse, defaultRequestHandler } from '../common/Fetcher';

export const getAffiliationCodeList = (code: string): Promise<AnyResponse> =>
  defaultRequestHandler(
    axios.get(`/affiliations`, {
      params: { code },
    }),
  );
